export default "__VITE_ASSET__B5KTAyCz__"